import { CustomerDetail } from '@/model'
import { useAtom } from 'jotai'
import { useAsyncEffect } from 'ahooks'
import { api } from '@/service'
import { useEffect, useState } from 'react'
import { isLogin } from '@/utils'
import { isJA } from "@/utils/language";
import dayjs from 'dayjs'
import { onClient } from '@/utils/util'
const ActivityModalExpressFee = () => {
  const [isShow, setIsShow] = useState(false)
  // useEffect(() => {
  //   onClient(() => {
  //     const timeIn = new Date().getTime() > new Date('2025/09/30 23:59:59').getTime() && location.href?.includes('/media')
  //     setIsShow(timeIn)
  //   })
  // })
  return (
    !isLogin() && isShow && isJA() &&  (
      <div>
        {/* pc */}
        <div className="fixed  w-full bottom-0 left-0 mo:hidden h-[120px]  z-[40]" style={{background:'url("https://static-jp.theckb.com/static-asset/activity/expressFee/bg_line.png")', backgroundRepeat: 'repeat',backgroundSize: 'contain'}}>
        <div className='w-[1200px] mx-auto pl-[60px] flex justify-between items-center'>
          <img src="https://static-jp.theckb.com/static-asset/activity/expressFee/express_fee_title.png" alt="" className='h-[120px]'/>
          <div className=' bg-[#00549D] text-[#fff] h-[68px] leading-[68px] px-[20px] rounded-full font-bold text-[24px] cursor-pointer' onClick={() => {
              const urlData = location.href.includes('media/article/') ? 'express_media_detail' : 'express_media_list'
              window.location.href = `/signup?utm_source=${urlData}`
            }}>無料登録で詳細料金を見る</div>
        </div>
        </div>
        {/* h5 */}
        <div className="fixed  bottom-0 left-0 w-full  pc:hidden z-[40]">
          <img
            src="https://static-jp.theckb.com/static-asset/activity/expressFee/express_fee_h5.png"
            alt=""
            className="w-full cursor-pointer"
            onClick={() => {
              const urlData = location.href.includes('media/article/') ? 'express_media_detail' : 'express_media_list'
              window.location.href = `/signup?utm_source=${urlData}`
            }}
          />
        </div>
      </div>
    )
  )
}
export default ActivityModalExpressFee
